export enum EParcelType {
  None = 0,
  EDelivery = 1,
  EncryptedEDelivery = 2,
  NotaEncrypted = 4,
  Email = 8,
  ExternalEDelivery = 16,
  Puh = 32,
  Epuap = 64,
  TraditionalLetter = 256,
  CourtPortalWriting = 512,
  ContactMessage = 1024,
}
